import { supabase } from '~/supabase-client'
import { DEFAULT_PREFERENCES } from './user-defaults.js'
export { DEFAULT_PREFERENCES }

export const createUserProfile = async ({ id, username, email }) => {
  return supabase.from('users').insert({
    id,
    username,
    email,
    permissions: 2,
    preferences: DEFAULT_PREFERENCES,
    features: [],
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
  })
}
